module.exports = __webpack_public_path__ + "onboarding-worker.b56511368ae6b71dc13a628501b89e3b.hashedasset.svg";